import { get } from 'helpers/api';

export function loadFields() {
  return async (dispatch, getState) => {
    const { deal, paths } = getState();

    const fields = await get(paths.fields, {
      params: {
        dealType: deal.dealType,
        stage: deal.stage,
        countryId: deal.countryId,
        propertyTypeId: deal.propertyTypeId,
      },
    });

    dispatch(setFields(fields));
  };
}

export const SET_FIELDS = 'SET_FIELDS';
export function setFields(fields) {
  return {
    type: SET_FIELDS,
    fields,
  };
}
